module.exports = __webpack_public_path__ + "resources/img/solution_game_en.21bd07942aa6c79614e0dafaf0bf8a40.jpg";